exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/*\n * Переменные\n */\n.test-question-answer-options[data-v-539c6a55] {\n  padding: 0 15px;\n}\n.test-question-answer-option-container[data-v-539c6a55] {\n  padding: 17px 0;\n}", ""]);

// exports
